import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { actions } from 'appRedux/modules/TabToggler';
import { LabBtn as Btn } from './LabBtn'


const mapStateToProps = (state, ownProps) => ({});
const mapDispatchToProps = (dispatch, ownProps) => ({
	onProfileClick: () => dispatch(actions.changeTab('profile', 1)),
});
const LabBtn = withRouter(connect(mapStateToProps, mapDispatchToProps)(Btn))


export { LabBtn }
